import React, { useMemo } from "react";
import ActivityLoader from "../Common/ActivityLoader";
import Notification from "../Common/Notification";
import functions from "../../util/functions";

const safe = (v) => (v === null || v === undefined || v === "" ? "—" : v);

const VendorTransactions = ({ transactions }) => {
  const list = useMemo(
    () => (Array.isArray(transactions) ? transactions : []),
    [transactions]
  );

  const isLoading = !transactions;
  const is404 = transactions === "404";

  return (
    <div className="card shadow-sm">
    {/* Header */}
     <div className="rac-head d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{ gap: 12 }}>
              <div className="rac-headIcon">
                <i className="fa fa-book-open" />
              </div>
              <div>
                <h6 className="rac-title">Transaction history</h6>
                <div className="rac-sub">Extracted ledgers for this vendor</div>
              </div>
            </div>
    
            <div className="rac-headBadge badge badge-light border" style={{ fontWeight: 600 }}>
              {isLoading ? "…" : `${list.length} item${list.length === 1 ? "" : "s"}`}
            </div>
          </div>


  

      {/* Body */}
      <div className="card-body pt-2">
        {isLoading && (
          <div className="py-3">
            <ActivityLoader />
          </div>
        )}

        {is404 && (
          <Notification message="No transaction record found" closable={false} />
        )}

        {!isLoading && !is404 && list.length === 0 && (
          <div className="text-center text-muted py-4">
            <i className="fa fa-info-circle mr-2" />
            No transactions yet.
          </div>
        )}

        {!isLoading && !is404 && list.length > 0 && (
          <div
            className="table-responsive overflow-auto"
            style={{
              maxHeight: 520,
              // overflowY: "auto",
              // borderRadius: 12,
              // border: "1px solid rgba(0,0,0,.06)",
            }}
          >
            <table className="table table-hover table-striped table-bordered">
              <thead>
                <tr>
                  <th>Trans date</th>
                  <th>Ledger #</th>
                  <th>Description</th>
                  <th>Amount (UGX)</th>
                  <th>Account</th>
                </tr>
              </thead>

              <tbody>
                {list.map((t, index) => (
                  <tr key={t?.id ?? index}>
                    <td>
                      {functions.formatDate(t.transaction_date)}
                    </td>
                    <td>{t.ledger_no}</td>
                    <td>{safe(t.description)}</td>
                    <td>{functions.numberFormat(t.amount)}</td>
                    <td>{safe(t?.account?.account_name)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorTransactions;
